import { ArrowRight } from 'lucide-react';
import posthog from 'posthog-js';
import { useNavigate } from 'react-router';

import type { components } from 'wg-api-sdk';

import Button from '@/components/common/Button';
import { useEmail } from '@/components/providers/EmailProvider/EmailProvider';
import useSelectedParty from '@/features/analysis/hooks/useSelectedParty';
import useReplyToClientActionsStore from '@/features/compose/stores/useReplyToClientActionsStore';
import type { ConceptReplyRequest } from '@/features/compose/types';
import paths from '@/lib/paths';

type Props = {
  action: components['schemas']['OnesuranceAction'];
};

export default function ActionMailCustomer({ action }: Props) {
  const {
    analysis: { email },
  } = useEmail();
  const party = useSelectedParty();
  const navigate = useNavigate();
  const replyToClientActions = useReplyToClientActionsStore(
    (state) => state.actions,
  );

  const handleClick = () => {
    posthog.capture('Onesurance action clicked', {
      actionType: 'MAIL_CUSTOMER',
      order: action.order,
      messageId: email?.message_id,
      emailId: email?.id,
      partyId: party?.id,
    });

    replyToClientActions.updateActions(email?.message_id ?? '', []);

    const request: ConceptReplyRequest = {
      source: 'onesurance-action',
    };

    navigate(paths.conceptReply, { state: request });
  };

  return (
    <Button
      variant={action.order === 1 ? 'default' : 'secondary'}
      size="xs"
      onSubmit={handleClick}
    >
      {action.title}

      <ArrowRight />
    </Button>
  );
}
